function e(t) {
  return t !== "ownerState" && t !== "theme" && t !== "sx" && t !== "as";
}
export {
  e as default
};
